export class ReferralCreditView {
    customerId: number;
    availableEarned: number;
    availableEarnedDisplay: string;
    lifetimeEarned: number;
    lifetimeEarnedDisplay: string;
    credits: IReferralCredit[];
    totalReferredOrders: number;
    annualEarned: number;
    annualEarnedDisplay: string;
    taxLimit: number;
    taxLimitDisplay: string;
    exceededTaxLimit: boolean;

    constructor() {
        this.credits = [];
    }
}

export interface IReferralCredit {
    creditCount: number;
    availableTotal: number;
    availableTotalDisplay: string;
    title: string;
    expirationDate: string;
    lineItems: IReferralLineItem[];
}

export interface IReferralLineItem {
    type: string;
    amount: number;
    amountDisplay: string;
    amountTotal: number;
    amountTotalDisplay: string;
    typeDisplay: string;
    entryDate: string;
}

export interface IAoReferralCreditRequest {
    customerId?: number;
    enabled: boolean;
}
